/**
 * Соответствие категории (`offer.category` без суффикса Rent/Sale)
 * подписи во множественной форме для подзаголовка мультиобъявления (Heading4).
 */
export const MULTI_ADS_TYPE_PLURAL: Record<string, string> = {
  office: 'Офисы',
  shoppingArea: 'Торговые площади',
  warehouse: 'Склады',
  freeAppointmentObject: 'Свободного назначения',
  industry: 'Помещения под производство',
  publicCatering: 'Общепит',
  manufacture: 'Производства',
  autoService: 'Автосервисы',
  building: 'Здания',
  domesticServices: 'Бытовые услуги',
  commercialLand: 'Коммерческая земля',
};

/**
 * Соответствие категории подписи в единственной форме
 * для колонки «Тип» в таблице помещений мультиобъявления.
 */
export const MULTI_ADS_AREA_PART_TYPE: Record<string, string> = {
  office: 'Офис',
  shoppingArea: 'Торговая площадь',
  warehouse: 'Склад',
  freeAppointmentObject: 'Своб. назнач.',
  industry: 'Под производство',
  manufacture: 'Производство',
};
